import React from "react";
import aboutImage from "../../assets/images/about/home3/1.png";
import authorImage from "../../assets/images/about/home3/5.png";
import Israel from "../../assets/images/about/home3/Israel.jpg";
// import Adewumi from "../../assets/images/about/home3/Adewumi.png";

const About = () => {
  return (
    <div>
      <section
        className="about about--style3 padding-bottom"
        style={{ marginTop: "30px" }}
      >
        <div className="container">
          <div className="about__wrapper">
            <div className="row g-4 align-items-center">
              <div className="col-md-6">
                <div
                  className="about__thumb about__thumb--style4"
                  dataaos="fade-right"
                  dataaosduration="800"
                >
                  <div className="about__thumb-inner">
                    <div className="about__thumb-image text-center floating-content">
                      <img
                        className="dark"
                        src={aboutImage}
                        alt="about-image"
                      />
                      <div
                        className="floating-content__bottom-left floating-content__bottom-left--style3"
                        dataaos="fade-right"
                        dataaosduration="1000"
                      >
                        <div
                          className="floating-content__item floating-content__item--style4"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="floating-content__item-thum">
                            <img src={Israel} alt="author" />
                          </div>
                          <div className="floating-content__item-content">
                            <p>Oluwasegun Israel</p>
                            <span>CEO/Founder</span>
                          </div>
                        </div>
                        {/* <div className="floating-content__item floating-content__item--style4">
                          <div className="floating-content__item-thum">
                             <img src={Adewumi} alt="author" /> 
                          </div>
                          <div className="floating-content__item-content">
                            <p>Adewumi Grace</p>
                            <span>Adewumi Grace</span>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div
                  className="about__content"
                  dataaos="fade-left"
                  dataaosduration="800"
                  style={{ textAlign: "left" }}
                >
                  <h2
                    style={{
                      textAlign: "left",
                      color: "#000000",
                      lineHeight: "1.3",
                      marginBottom: "20px",
                      fontWeight: 700,
                    }}
                  >
                    Meet
                    <span style={{ color: "#000080" }}> With Us </span>
                    Your Trusted Partner in Forex Success
                  </h2>
                  <p
                    className="mb-0"
                    style={{
                      textAlign: "left",
                      color: "#000000",
                      lineHeight: "1.8",
                      fontSize: "16px",
                      marginBottom: "28px",
                    }}
                  >
                    At ProTradesInsight, we are more than just a Forex trading
                    company. We are a hub of knowledge, mentorship, and
                    empowerment designed to help you achieve financial success.
                    With years of hands-on experience in the financial markets,
                    we provide exclusive VIP signals, expert tutoring, and
                    insightful market analysis tailored for both beginners and
                    seasoned traders. Our professional team works tirelessly to
                    deliver valuable resources that give you the confidence and
                    edge needed to navigate the ever-changing world of forex.
                    Whether you're just starting out or looking to refine your
                    trading skills, ProTradesInsight is committed to guiding you
                    every step of the way toward consistent growth and success.
                  </p>
                  <div style={{ textAlign: "left" }}>
                    <a
                      href="about.html"
                      className="trk-btn trk-btn--border trk-btn--primary"
                      style={{ display: "inline-block" }}
                    >
                      Explore More
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;